import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0.5rem',
    width: '4rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  actionButton: { textTransform: 'uppercase', padding: 0 },
  longFileInfo: {
    width: '7rem',
    wordBreak: 'break-all',
    paddingRight: '2rem',
  },
  policyIdsList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  policyId: {
    wordBreak: 'break-all',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
